<script>
export default {
  props: {
    items: {
      type: Array,
      default: null,
    },

    address: {
      type: String,
      default: '',
    },
    infoModal: {
      type: Object,
      default: null,
    },
    infoModalid: {
      type: String,
      default: '',
    },
    infoModaltitle: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    ipAddress: {
      type: String,
      default: '',
    },
    infoModalcontent: {
      type: Array,
      required: true,
    },
  },

  methods: {
    isBorrowerDetails(item) {
      var isBorrower = ''
      if (item.city !== '' && item.city !== undefined && item.city !== null) {
        isBorrower = item.city + ',' + ' ' + item.state + '-' + item.zipCode
      }
      return isBorrower
    },
    isCoBorrowerDetails(item) {
      var isCoBorrower = ''
      if (
        item.coapplicantCity !== '' &&
        item.coapplicantCity !== undefined &&
        item.coapplicantCity !== null
      ) {
        isCoBorrower =
          item.coapplicantCity +
          ',' +
          ' ' +
          item.coapplicantState +
          '-' +
          item.coapplicantZipCode
      }
      return isCoBorrower
    },

    itemsContains: function(item) {
      return item.indexOf('[Error]') > -1
    },
    resetInfoModal() {
      this.infoModaltitle = ''
      this.infoModalcontent = ''
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      :id="id"
      size="lg"
      title="Activity Details"
      hide-footer
      @hide="resetInfoModal"
    >
      <b-container>
        <div class="row mb-1 border-bottom py-2">
          <div class="col-6">
            <div class="col-12 p-0">
              <span :class="$style.labelHeader">Customer:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.lenderName
              }}</span>
            </div>
            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">Loan Officer:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.loanOfficerName
              }}</span></div
            >
          </div>
          <div class="col-6 p-0">
            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">IP Address:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.ipAddress
              }}</span></div
            >
            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">Date of Request:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.dateofRequest
              }}</span></div
            >
            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">Date of Response:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.dateofResponse
              }}</span></div
            >
          </div>
        </div>
        <div class="row mb-1 border-bottom py-3">
          <div class="col-6">
            <BaseELabel size="md" label="Borrower Details" />
            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">Name:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.consumerName
              }}</span></div
            >
            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">Email ID:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.emailAddress
              }}</span></div
            >
            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">Mobile Number:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.phoneNumber
              }}</span></div
            >
            <div class="col-12 p-0 d-flex"
              ><span :class="$style.labelHeader">Address: </span
              ><div
                ><p class="mb-0" :class="$style.fontData">{{
                  infoModalcontent.addressLine
                }}</p
                ><p class="mb-0" :class="$style.fontData">{{
                  isBorrowerDetails(infoModalcontent)
                }}</p></div
              ></div
            >
          </div>
          <div class="col-6 p-0">
            <BaseELabel
              :class="$style.labelMainHeader"
              label="Co-Borrower Details"
            />

            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">Name:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.coapplicantName
              }}</span></div
            >
            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">Email ID:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.coapplicantEmailAddress
              }}</span></div
            >
            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">Mobile Number:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.coapplicantPhoneNumber
              }}</span></div
            >
            <div class="col-12 p-0"
              ><span :class="$style.labelHeader">Address:</span>
              <span :class="$style.fontData">{{
                infoModalcontent.coapplicantAddressLine
              }}</span></div
            >
            <div class="col-12 p-0"
              ><span></span
              ><span :class="$style.fontData">{{
                isCoBorrowerDetails(infoModalcontent)
              }}</span></div
            >
          </div>
        </div>
        <div class="row border-bottom pt-3"
          ><div class="col-12"
            ><BaseELabel size="md" label="Criteria:"/><span> </span
          ></div>
          <div class="col-12"
            ><span :class="$style.labelHeader">Credit Score Achieved:</span>
            <span></span></div
        ></div>
        <div class="row border-bottom py-3"
          ><div class="col-12"
            ><BaseELabel size="md" label="Qualified Products:" /><span
              :class="$style.fontData"
              >{{ infoModalcontent.name }}</span
            ></div
          >
        </div>
        <!-- started Activity log  -->
        <div class="py-3">
          <BaseELabel size="md" label="Activity Log:" />
          <ul :class="$style.events" class="p-0">
            <li
              v-for="itemAddress in infoModalcontent.consumerActivityLogs"
              :key="itemAddress.id"
            >
              <time>{{ itemAddress.eventDateTime }}</time>
              <div
                :class="$style.circle"
                class="{ active: '', 'bg-danger': itemsContains(itemAddress.message) }"
              ></div>
              <span
                class="{ active: '', 'text-danger': itemsContains(itemAddress.message) }"
              >
                {{ itemAddress.message }}
              </span>
            </li>
          </ul>
        </div>
      </b-container>
      <hr class="mt-0" />
      <div class="float-right">
        <BaseEButton name="ok" size="sm" @click="$bvModal.hide(id)"
          >OK</BaseEButton
        >
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.btnHover:hover {
  color: $color-text-white;
  background-color: #5a6268 !important;
}
.circle {
  z-index: 2;
  width: 0.98em;
  height: 0.8em;
  content: '';
  background-color: green;
  border: 1px rgb(204, 204, 204) solid;
  border-radius: 50%;
  transform: translateX(50%);
}
.events li {
  display: flex;
}
.events time {
  position: relative;
  width: 21%;
  padding: 0 2.5em 1.5em 0;
  font-size: 12px;
  color: #2f2f2f;
  text-align: right;
}
.events span {
  position: relative;
  width: 100%;
  padding: 0 2.5em 1.5em 1.5em;
  font-size: 12px;
}

.events span::before {
  position: absolute;
  left: -1px;
  z-index: 1;
  height: 100%;
  content: '';
  border-left: 2px solid #ccc;
}
.events li:last-child span::before {
  border-left: none;
}
.events strong {
  display: block;
  font-weight: bolder;
}

.events {
  width: 100%;
  margin: 1em;
}
.events:last-child {
  border-left: none;
}

.events *::before,
.events *::after {
  box-sizing: border-box;
}
.labelMainHeader {
  font-weight: 700;
}
.labelHeader {
  font-size: 15px;
  font-weight: 600;
}
.fontData {
  padding-left: 10px;
  font-size: 14px;
  word-break: break-all;
}
</style>
